import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const MOSAICCOMOCREATEACCOUNTCARDBLOCK_LEGACY_FIELD_ORDER = [
  "heading",
  "text",
  "background_color",
  "text_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  mosaicComoCreateAccountCardBlockDescriptor: _generatedMosaicComoCreateAccountCardBlockDescriptor,
  mosaicComoCreateAccountCardBlockBlocDefinition,
  mosaicComoCreateAccountCardBlockDashboardLayout,
  mosaicComoCreateAccountCardBlockConfig,
  mosaicComoCreateAccountCardBlockResolveConfig,
  mosaicComoCreateAccountCardBlockProperties,
} = doodBlockConfig(
  {
    name: "Como - Create account card",
    componentType: 'MosaicComoCreateAccountCardBlockComponent',
    category: 'como',
    description: "Como - Create account card.",
    keywords: [],
    allowedIn: [
      { bloc: "MosaicBlockComponent", slot: "cards" },
    ],
    sharedFields: {}
  },

  () => ({
    heading: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.mosaic-como-create-account-card.heading.label",
      }
    }),
    text: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.mosaic-como-create-account-card.text.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"highlight-600"},
      options: {
        label: "pages.blocks.mosaic-como-create-account-card.background-color.label",
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        label: "pages.blocks.mosaic-como-create-account-card.text-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.mosaic-como-create-account-card.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.mosaic-como-create-account-card.fieldset.texts.label",
            fields: ["heading", "text", "text_color"],
          },
          {
            legend: "pages.blocks.mosaic-como-create-account-card.fieldset.background.label",
            fields: ["background_color"],
          },
        ],
      },
    ],
  })
);

export function mosaicComoCreateAccountCardBlockDescriptor(): IBlockDescriptor;
export function mosaicComoCreateAccountCardBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function mosaicComoCreateAccountCardBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedMosaicComoCreateAccountCardBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedMosaicComoCreateAccountCardBlockDescriptor, mosaicComoCreateAccountCardBlockProperties, fieldOrder);
}

export {
  mosaicComoCreateAccountCardBlockBlocDefinition,
  mosaicComoCreateAccountCardBlockDashboardLayout,
  mosaicComoCreateAccountCardBlockProperties,
  mosaicComoCreateAccountCardBlockConfig,
  mosaicComoCreateAccountCardBlockResolveConfig,
};

export type MosaicComoCreateAccountCardBlockConfig = typeof mosaicComoCreateAccountCardBlockConfig;
